import React, { useState } from 'react';
import { EmptyPage } from '../EmptyPage';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from '../../components/Select';
import { Input } from '../../components/Input';
import { updateSettings } from '../../redux/settingSlice';
import { Button } from '../../components/Button';
import {ReactComponent as Bin} from '../../assets/bin.svg';
// import Bin from '../../assets/bin.svg';

const ProfileLimit = ({min, percent, index, createLimit, updateLimit, deleteLimit}) => {
    const [localMin, setLocalMin] = useState(min);
    const [localPercent, setLocalPercent] = useState(percent);
    const setMinHandler = (index) => {
        updateLimit(index-1, 'min', localMin);
    }
    const setPercentHandler = (index) => {
        updateLimit(index-1, 'percent', localPercent);
    }
    return (
        <div className='profile-limit'>
            <div className="profile-limit__nav top" onClick={() => createLimit(index-1)}><div></div></div>
            <div className="profile-limit__content">
                <div>
                    <span>От</span>
                    <Input min={0} type='number' onBlur={() => setMinHandler(index)} value={localMin} changeHandler={(e) => setLocalMin(+e.target.value)} />
                    <span>Руб</span>
                </div>
                <div>
                    <span>к сдаче</span>
                    <Input min={1} max={100} type='number' onBlur={() => setPercentHandler(index)} value={localPercent} changeHandler={(e) => setLocalPercent(+e.target.value)} />
                    <span>% мастеру</span>
                </div>
                <div className="profile-limit__delete" onClick={() => deleteLimit(index-1)}>
                    <Bin />
                </div>
            </div>
            <div className="profile-limit__nav bottom" onClick={() => createLimit(index)}><div></div></div>
        </div>
    )
}

const ProfileSettings = ({data, updateBonus, updateLowerLimit, createLimit, updateLimit, deleteLimit}) => {

    const {profileType, IS_PROFILE_LOWER_LIMIT:lowerLimit, notProfilePercentBonus:bonus, limits} = data;

    return (
        <div className='calculation__profile profile-settings'>
            <div className='profile-settings__general'>
                <div>
                    <Input min={1} label='Непрофиль -> профиль с (руб)' type='number' value={lowerLimit} changeHandler={(e) => updateLowerLimit(+e.target.value)} />
                </div>
                <div>
                    <Input min={0} max={100} label='Бонус за непрофиль (%)' type='number' value={bonus} changeHandler={(e) => updateBonus(+e.target.value)} />
                </div>
            </div>
            <div className='profile-settings__limits'>
                {limits.map((l, index, arr) => <ProfileLimit deleteLimit={deleteLimit} updateLimit={updateLimit} index={index+1} createLimit={createLimit} key={`${index}_${profileType}_${l.min}_${l.max}_${arr.length}`} min={l.min} percent={l.percent} />)}
            </div>
        </div>
    )
}

export const Calculation = ({isSystemAccount}) => {

    const profiles = useSelector((state) => state.settings.orderProfiles);
    const calcSettings = useSelector((state) => state.settings.calculation);
    const rejectSettings = calcSettings.ORDER_REJECT_TIMEOUT;

    const getMsFromMin = (min) => min*60*1000;
    const getMinFromMs = (ms) => ms/(60*1000);

    const [rejectOrder, setRejectOrder] = useState(rejectSettings.enabled);
    const [rejectTime, setRejectTime] = useState(getMinFromMs(rejectSettings.timeout));
    const [rejectFineAmount, setRejectFineAmount] = useState(calcSettings.ORDER_NOT_ACCEPTED_FINE_AMOUNT);
    const [warrantyLimit, setWarrantyLimit] = useState(calcSettings.WARRANTY_UPPER_LIMIT);
    
    const [profile, setProfile] = useState(profiles[0]._id);

    const isGeneralChanged = (() => {
        return rejectOrder !== rejectSettings.enabled ||
        getMsFromMin(rejectTime) !== rejectSettings.timeout ||
        rejectFineAmount !== calcSettings.ORDER_NOT_ACCEPTED_FINE_AMOUNT ||
        warrantyLimit !== calcSettings.WARRANTY_UPPER_LIMIT
    })();

    const dispatch = useDispatch();
    const updateGeneralHandler = () => {
        const updatedSets = {
            isReject: rejectOrder,
            rejectTimeout: getMsFromMin(rejectTime),
            fineAmount: rejectFineAmount,
            warrantyLimit,
            type: 'general'
        }
        dispatch(updateSettings({updatedSets}));
    }

    const [profileSets, setProfileSets] = useState(calcSettings.calculation);

    const updateProfileBonus = (profileType) => (bonus) => {
        setProfileSets(profileSets.map((profObj) => profObj.profileType === profileType
        ? ({...profObj, notProfilePercentBonus: bonus}) : profObj))
    }
    const updateProfileLowerLimit = (profileType) => (limit) => {
        setProfileSets(profileSets.map((profObj) => profObj.profileType === profileType
        ? ({...profObj, IS_PROFILE_LOWER_LIMIT: limit}) : profObj))
    }
    const createLimit = (profileType) => (index) => {
        setProfileSets(profileSets.map((profObj) => profObj.profileType === profileType
        ? ({...profObj, limits: (function(){
            const newLimits = [...profObj.limits];
            newLimits.splice(index, 0, {min: 0, percent: 0});
            return newLimits;
        })()}) : profObj))
    }
    const updateProfileLimit = (profileType) => (index, name, value) => {
        setProfileSets(profileSets.map((profObj) => profObj.profileType === profileType
        ? ({...profObj, limits: profObj.limits.map((l, i) => index === i ? ({min: name === 'min' ? value : l.min, percent: name === 'percent' ? value : l.percent}) : l)}) : profObj))
    }
    const deleteProfileLimit = (profileType) => (index) => {
        setProfileSets(profileSets.map((profObj) => profObj.profileType === profileType
        ? ({...profObj, limits: profObj.limits.filter((l, i, arr) => arr.length > 1 ? index !== i : true)}) : profObj))
    }

    const saveProfileSettings = () => {
        dispatch(updateSettings({updatedSets: {profileSets, type: 'profile'}}));
    }
    if (!isSystemAccount) {
        return <EmptyPage message="Нет доступа к данной странице" /> 
    }
    return (
        <div className='calculation-page page'>
            <div className="calculation">
                <h2>Редактирование настроек</h2>
                <div className="calculation__header">
                    <h3>Общие настройки</h3>
                    <div className="calculation__reject-settings">
                        <div>
                            <input type='checkbox' id='switchTimer' checked={rejectOrder || false} onChange={(e) => setRejectOrder(prev => !prev)} />
                            <label style={{marginLeft: '4px'}} htmlFor="switchTimer">Отзывать непринятые заявки</label>
                        </div>
                        <div>
                            <Input min={1} disabled={!rejectOrder} label='Отзывать через (мин)' type='number' value={rejectTime} changeHandler={(e) => setRejectTime(+e.target.value)} />
                        </div>
                        <div>
                            <Input min={1} disabled={!rejectOrder} label='Штраф за непринятую заявку (руб)' type='number' value={rejectFineAmount} changeHandler={(e) => setRejectFineAmount(+e.target.value)} />
                        </div>
                    </div>
                    <div className="calculation__other-settings">
                        <div>
                            <Input label='Гарантии до (руб)' type='number' min={1} value={warrantyLimit} changeHandler={(e) => setWarrantyLimit(+e.target.value)} />
                        </div>
                    </div>
                    <div className="calculation__save">
                        <Button disabled={!isGeneralChanged} text={true ? 'Сохранить общие настройки' : 'Нет изменений для сохранения'} onClick={updateGeneralHandler}/>
                    </div>
                    <hr />
                    <div className="calculation__body">
                        <h3>Профильные настройки</h3>
                        <div className="calculation__select">
                            <span>Выберите профиль</span>
                            <Select enums={profiles} value={profile} changeHandler={(e) => setProfile(e.target.value)}/>
                        </div>
                        <ProfileSettings
                            data={profileSets.find(profObj => profObj.profileType === profile)}
                            updateBonus={updateProfileBonus(profile)}
                            updateLowerLimit={updateProfileLowerLimit(profile)}
                            createLimit={createLimit(profile)}
                            updateLimit={updateProfileLimit(profile)}
                            deleteLimit={deleteProfileLimit(profile)}
                        />
                        <div className="calculation__save">
                            <Button disabled={false} text={true ? 'Сохранить профильные настройки' : 'Нет изменений для сохранения'} onClick={saveProfileSettings}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
